/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

const reviewPropTypes = PropTypes.shape({
	id: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
	title: PropTypes.string,
	text: PropTypes.string.isRequired,
	rating: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]).isRequired,
	upVotes: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]).isRequired,
	downVotes: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]).isRequired,
	dateCreated: PropTypes.string.isRequired,
	purchaseDate: PropTypes.string,
	reviewedDate: PropTypes.string,
	media: PropTypes.shape({
		photo: PropTypes.arrayOf(PropTypes.any)
	}),
	user: PropTypes.shape({
		firstName: PropTypes.string.isRequired,
		lastName: PropTypes.string.isRequired,
		nickName: PropTypes.string
	})
});

const starRatingTypes = {
	rating: PropTypes.number.isRequired,
	size: PropTypes.oneOf([ 'xSmall', 'small', 'normal', 'large' ]),
	showSummaryText: PropTypes.bool,
	styleVariant: PropTypes.string
};

export { reviewPropTypes, starRatingTypes };
